// Captain ROCA — Parcours recommandé (Ocean Navigator journey)
// Sequence designed for dyslexic-friendly step-by-step discovery.
// Each step has a stable id, a route, and trilingual labels.

export type JourneyStep = {
  id: string;
  path: string;
  emoji: string;
  en: { title: string; subtitle: string };
  fr: { title: string; subtitle: string };
  es: { title: string; subtitle: string };
};

export const JOURNEY: JourneyStep[] = [
  {
    id: "home",
    path: "/",
    emoji: "🧭",
    en: { title: "Discover Captain ROCA", subtitle: "Understand the map" },
    fr: { title: "Découvrir Captain ROCA", subtitle: "Comprendre la carte" },
    es: { title: "Descubre Captain ROCA", subtitle: "Entiende el mapa" },
  },
  {
    id: "crr",
    path: "/crr-zone-1",
    emoji: "📡",
    en: { title: "Learn the CRR basics", subtitle: "Radio licence Zone 1 → 4" },
    fr: { title: "Apprendre le CRR", subtitle: "Licence radio Zone 1 → 4" },
    es: { title: "Aprender el CRR", subtitle: "Licencia radio Zona 1 → 4" },
  },
  {
    id: "briefings",
    path: "/briefings",
    emoji: "🛟",
    en: { title: "Read the safety briefings", subtitle: "Step-by-step jet & boat safety" },
    fr: { title: "Lire les briefings sécurité", subtitle: "Sécurité jet & bateau pas à pas" },
    es: { title: "Leer los briefings", subtitle: "Seguridad jet y barco paso a paso" },
  },
  {
    id: "master-builder",
    path: "/bpjeps-master-builder",
    emoji: "🏗️",
    en: { title: "Build your BPJEPS manual", subtitle: "BC1 → BC2 → BC3 → BC4" },
    fr: { title: "Construire votre manuel BPJEPS", subtitle: "BC1 → BC2 → BC3 → BC4" },
    es: { title: "Construir tu manual BPJEPS", subtitle: "BC1 → BC2 → BC3 → BC4" },
  },
  {
    id: "careers",
    path: "/maritime-careers",
    emoji: "⚓",
    en: { title: "Explore maritime careers", subtitle: "Find your role at sea" },
    fr: { title: "Explorer les carrières maritimes", subtitle: "Trouver votre rôle en mer" },
    es: { title: "Explorar carreras marítimas", subtitle: "Encuentra tu rol en el mar" },
  },
  {
    id: "permis",
    path: "/permis-academy",
    emoji: "🎓",
    en: { title: "Get your boat licence", subtitle: "Permis Côtier & Fluvial" },
    fr: { title: "Obtenir votre permis bateau", subtitle: "Permis Côtier & Fluvial" },
    es: { title: "Obtener tu licencia náutica", subtitle: "Permiso Costero y Fluvial" },
  },
];

export type Lang = "en" | "fr" | "es";

export const getStepIndex = (id: string) =>
  JOURNEY.findIndex((s) => s.id === id);

export const getStep = (id: string) => JOURNEY.find((s) => s.id === id);

export const getNextStep = (id: string) => {
  const i = getStepIndex(id);
  if (i < 0 || i >= JOURNEY.length - 1) return null;
  return JOURNEY[i + 1];
};

export const getPrevStep = (id: string) => {
  const i = getStepIndex(id);
  if (i <= 0) return null;
  return JOURNEY[i - 1];
};
